import { useEffect, useState } from "react";
import HeroSection from "../component/HeroSection";
import NavBar from "../component/NavBar";
import Dropdown from "../component/Dropdown";
import Features from "../component/Features";
import Details from "../component/Details";
import Benefits from "../component/Benefits";
import Pricing from "../component/Pricing";
import Footer from "../component/Footer";
import DemoVideo from "../component/DemoVideo";
import Mobile from "../component/Mobile";
import Loading from "../component/StaffifyLoading";
import { AppContext } from "../context/context";

function Home() {
  const [state, setState] = useState({
    loadedImages: 0,
    showDemo: false,
    showDropdown: false,
  });

  useEffect(() => {
    if (state.showDemo) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [state.showDemo]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: "smooth" });
    setState((ps) => ({ ...ps, showDropdown: false }));
  };

  return (
    <AppContext.Provider value={{ state, setState }}>
      <div
        className={`w-full h-fit block ${state.showDemo && "overflow-hidden"}`}
      >
        <NavBar scroll={scrollToSection} />
        <Dropdown scroll={scrollToSection} />
        <HeroSection />
        <Features />
        <Details />
        <Mobile />
        <Benefits />
        <Pricing scroll={scrollToSection} />
        <Footer />

        {state.showDemo && <DemoVideo />}
        {state.loadedImages < 8 && <Loading />}
      </div>
    </AppContext.Provider>
  );
}

export default Home;
